import React from 'react';
import { Check } from 'lucide-react';
import { LeafDivider, Section } from './Shared';
import { libraryChecks } from '../data/landing';
export const PainPoints = () => <Section className="max-w-3xl" data-id="element-160" data-mp="2lp54ep1tmysm">
    <h2 className="text-[28px] md:text-5xl font-display font-bold leading-tight text-brand-purpleDark text-center" data-id="element-161" data-mp="26z7osxhyjhf1">
      ¿Cuánto tiempo dedicas a reunir información antes de cada consulta?
    </h2>

    <div className="mt-8 space-y-4 text-base md:text-lg text-brand-text leading-relaxed text-center" data-id="element-162" data-mp="1xxhw7occacfo">
      <p className="font-display italic text-xl md:text-2xl text-brand-goldDark" data-id="element-163" data-mp="21zl8ugaqvn2j">
        Un dato en un libro. Una preparación en tus apuntes. Una ficha en otra
        carpeta.
      </p>
      <p data-id="element-164" data-mp="1sy500czkvt0f">
        Conoces las plantas, pero encontrar y ordenar tus recursos también
        lleva tiempo.
      </p>
      <p data-id="element-165" data-mp="3iemle069879m">
        Y cuando un paciente vuelve, necesitas retomar sus antecedentes, tus
        observaciones y el seguimiento.
      </p>
    </div>

    <LeafDivider data-id="element-166" data-mp="3nabnob9ns29m" />

    <p className="text-center font-serif font-bold text-lg md:text-2xl text-brand-purpleDark" data-id="element-167" data-mp="1z0f0ax1kva7f">
      Saberes Ancestrales™ reúne esos recursos en una biblioteca que puedes
      tener a mano.
    </p>

    <ul className="mt-7 max-w-xl mx-auto space-y-3" data-id="element-168" data-mp="27sqoec97ylk8">
      {libraryChecks.map(item => <li key={item} className="flex items-start gap-3" data-id="element-169" data-mp="23rdm2c5c50i2">
          <span className="mt-0.5 w-6 h-6 rounded-full bg-brand-lime/30 flex items-center justify-center shrink-0" data-id="element-170" data-mp="23rwzbfk1j0pr">
            <Check className="w-4 h-4 text-brand-purpleDark" strokeWidth={3} data-id="element-171" data-mp="1g3x2bxw4ye2q" />
          </span>
          <span className="text-base md:text-lg text-brand-text" data-id="element-172" data-mp="1b4stj8d4iicx">{item}</span>
        </li>)}
    </ul>

    <p className="mt-9 text-center font-display italic text-xl md:text-2xl text-brand-purple" data-id="element-173" data-mp="1p04mba7pxyr7">
      Tu experiencia merece herramientas que acompañen tu trabajo.
    </p>
  </Section>;